module.exports = __webpack_public_path__ + "media/images/icon-kakao-share-34328a42d18a220d863e8b386d51e35d.png";